import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductPage from "../pages/product/page";
import ContactPage from "../pages/contact/page";
import ComingSoonPage from "../pages/coming-soon/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/product/:id",
    element: <ProductPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/coming-soon",
    element: <ComingSoonPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
